import { MarketingService } from "./../../services/marketing/marketing.service";
import { UserServiceService } from "./../../services/user-service/user-service.service";
import { environment } from "./../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { ErrorHandlerService } from "./../../services/shared/error-handler.service";
import {
  Component,
  NgZone,
  ElementRef,
  ViewChild,
  ViewContainerRef,
  OnInit,
} from "@angular/core";
import { LeadActivity, LeadRequest } from "../../dtos/leadActivity.viewmodel";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { LeadStatus } from "../../dtos/leadStatus.viewmodel";
import { Router, ActivatedRoute } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { Image } from "angular-modal-gallery";
import { ProjectsService } from "../../services/projects/projects.service";
import { HelpdeskService } from "../../services/helpdesk/helpdesk.service";
import { isFutureDateTime, removeNullishFieldsParams } from "../../shared/object_helpers";
declare var Messenger: any;

@Component({
  selector: "leads",
  templateUrl: "./lead.component.html",
  styleUrls: ["./lead.component.css"],
})
export class LeadsComponent implements OnInit {
  //#region  Definitions
  isFutureDateTime = isFutureDateTime;
  newLeadCount: number = 0;
  documentForm: FormGroup;
  filterForm: FormGroup;
  filterSubmitDisabled = false;
  @ViewChild("fileInput") fileInput: ElementRef;
  @ViewChild("logMessageModal") logMessageModal: any;
  @ViewChild("logPhoneCallModal") logPhoneCallModal: any;
  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));
  title = "lead";
  activity: LeadActivity = null;
  reminder: any = {
    title: null,
    details: null,
    reminder_datetime: null,
  };
  request: LeadRequest = null;
  lstatus: LeadStatus = null;
  filterStatus: LeadStatus = null;
  leads = null;
  leadActivities: Array<any> = [];
  status: Array<any> = [];

  // filter leads
  @ViewChild("leadsContainer") leadsContainer: ElementRef;
  filteredLeads: Array<any> = [];
  loadingFilteredLeads = false;

  leadDetails: any;
  selectedLead: any;
  agents: Array<any> = [];
  selectedAgentIds: number[] = [];
  private initializingAgentSelection = false;
  documentTypes: Array<any> = [];
  documentType;
  documentNumber;
  documentIssueDate;
  leadId;
  leadDocuments = null;
  imagesArray: Array<Image>;
  activityHeading: Array<any> = [];
  activitydetails: Array<any> = [];
  loadingIndicationElement: Element;
  @ViewChild("divscroll") inputs;
  leadStatus: any;
  leadsStatus: any;
  searchLeadsStatus: any;
  pcs: any;
  searchedPcs: any;
  teams: any;
  searchedTeams: any;
  leadChannels: any;
  searchedLeadChannels: any;
  searchLeadSources: any;
  searchedLeadSources: any;
  next_page_url: any;
  selector: string;
  file_name: string;
  fileToUpload: File = null;
  actions: any;
  document: any = {
    type: "",
  };
  uploadExcel: FormGroup;
  lead_source: any = "-1";
  leadSources: Array<any> = [];
  send_to_agent: any = "all";
  agentsArrayString: any = [];
  chosenAgent: any;
  arrSearch: any = [];
  dataFromSearch: any;
  isMarekting = false;
  export_lead: any;
  smsForm: any;
  smsgroup: any;
  emailForm: any;
  channels: any;
  channel: any;
  interest_project: any;
  brokers: any;

  adminComment: any;
  projects: any;
  searchedProjects: any;
  campaigns: any[];
  searchedCampaigns: any[];

  is_collapsed: boolean = true;
  types: any;

  lead_requests: any;
  activitiesForFilter: any;
  searchedActivitiesForFilter: any;

  lead_reminders: any;

  reminders: any;

  readOnlyMode: boolean = false;

  actions_is_collapsed: boolean = true;

  allChecked: boolean = false;
  selectedLeadsID: any[] = [];
  leadsTotal;
  selectedLeadsCount = 0;
  disableCheckbox: boolean = false;
  formValue;
  allLeadsChecked: boolean = false;
  rotations: any;

  reassignLeadsPayload: any = {
    reassign_user_id: null,
    select_all: false,
    leads_ids: [],
  };
  assign_type: "agent" | "rotation" = "agent";
  rotation_id: any;
  user_ids: any;
  orderTypes: any[] = [
    { id: "updated_at", name: "Last Updated" },
    { id: "created_at", name: "Last Created" },
    { id: "oldest_updated", name: "Oldest Updated" },
  ];
  searchedOrderTypes: any[] = this.orderTypes;
  interest_unit_types: any;


  meetingTypes: any[];
  setMeeting: any = {
    action_type: "meeting",
    meeting_type_id: null,
    due_date: null,
    event_type_id: null,
    event_status_id: null,
    notes: null,
    has_next_action: false
  };
  logPhoneCall: any = {
    action_type: "call",
    call_type_id: null,
    due_date: null,
    notes: null,
    has_next_action: false
  }
  logMessage: any = {
    action_type: "message",
    message_source_id: null,
    due_date: null,
    notes: null,
    has_next_action: false
  }
  meetingFeedback: any = {
    action_type: "feedback",
    feedback_status_id: null,
    meeting_type_id: null,
    note: null,
    has_next_action: false
  }
  nextAction: any = {
    next_action: null,
    next_action_meeting_type_id: null,
    next_action_due_date: null,
    next_action_event_type_id: null,
    next_action_event_status_id: null,
    next_action_call_type_id: null,
    next_action_message_source_id: null,
    next_action_feedback_status_id: null,
    next_action_feedback: null,
    next_action_status: null,
    next_action_notes: null
  };
  feedback: any = {
    action_type: "feedback",
    feedback: null,
    lead_action_id: null,
    event_status_id: null,
    feedback_status_id: null,
    next_action_notes: null,
  }
  nextActions: string[] = ["meeting", "call", "message"];
  firstAction
  eventTypes: any;
  eventStatuses: any;
  lead_id: number;
  callTypes: any;
  messageSources: any;
  feedbackStatuses: any;
  meetings: any[] = [];
  phoneLogs: any[] = [];
  messagesLogs: any[] = [];
  edit_action_mode: boolean;
  upload_excel_sheet: any;

  // Feedback visibility flags for past due dates
  showFeedbackInSetMeeting: boolean = false;
  showFeedbackInLogPhoneCall: boolean = false;
  showFeedbackInLogMessage: boolean = false;
  tickets: any[] = [];
  //#endregion

  constructor(
    private leadsService: LeadsService,
    private fb: FormBuilder,
    private router: Router,
    private _route: ActivatedRoute,
    private cookieService: CookieService,
    vRef: ViewContainerRef,
    private zone: NgZone,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private helpdeskService: HelpdeskService,
    private http: HttpClient,
    private userService: UserServiceService,
    private marketingService: MarketingService,
    private projectService: ProjectsService,
    private route: ActivatedRoute
  ) {
    this.createFilterForm();

    if (["filter_name"].some((f) => this.route.snapshot.queryParams[f])) {
      this.filterForm.patchValue({
        filter_name: this.route.snapshot.queryParams["filter_name"],
      });
      this.onFilterSubmit();
    } else {
      this.getLeads();
    }
    this.export_lead = `${
      environment.api_base_url
    }leads/export?token=${window.localStorage.getItem("token")}`;
    this.createForm();
    this.activity = new LeadActivity();
    this.request = new LeadRequest();
    this.lstatus = new LeadStatus();
    this.getStatus();
    this.getDocumnetTypes();
    this.getAllActions();
    if (this.userData.role != "Marketing") {
      this.leadSource();
    } else {
      this.leadSources = [
        {
          text: "facebook",
        },
        {
          text: "Youtube",
        },
        {
          text: "Adword",
        },
      ];
      this.isMarekting = true;
    }
    this.getAgents();
    console.log("user role : ", this.userData.role);
    this.marketingService.getChannels().subscribe((response) => {
      this.leadChannels = response;
      this.searchedLeadChannels = response;
    });
    this.http
      .get(`${environment.api_base_url}settings/sources`)
      .subscribe((data) => {
        this.searchLeadSources = data;
        this.searchedLeadSources = data;
      });
    //ro stands for readonly, it's intentionaly encrypted so that end user don't bypass it by changing the value from url
    this._route.queryParams.subscribe((params) => {
      this.readOnlyMode = params["ro"] == 1;
    });
  }

  ngOnInit() {
    this.getAllReminders();
    this.createSmSBulkForm();
    this.getChannels();
    this.createSmSgroupForm();
    this.createEmailBulkForm();
    this.getAllProjects();
    this.getAllCampaigns();
    this.getNewLeadStatus();
    this.getLeadStatus();
    this.getPcs();
    this.getSubTeams();
    this.getAllRotations();
    this.getMeetingTypes();
    this.getEventTypes();
    this.getEventStatuses();
    this.getCallTypes();
    this.getMessageSources();
    this.getFeedbackStatuses();
    this.zone = new NgZone({ enableLongStackTrace: false });
  }



  getMeetingTypes() {
    this.helpdeskService.getMeetingTypes().subscribe(
      (res: any) => {
        this.meetingTypes = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getEventTypes() {
    this.helpdeskService.getEventTypes().subscribe(
      (res: any) => {
        this.eventTypes = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getEventStatuses() {
    this.helpdeskService.getEventStatuses().subscribe(
      (res: any) => {
        this.eventStatuses = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getCallTypes() {
    this.helpdeskService.getCallTypes().subscribe((res: any) => {
      this.callTypes = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }

  getMessageSources() {
    this.helpdeskService.getMessageSources().subscribe((res: any) => {
      this.messageSources = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }

  getFeedbackStatuses() {
    this.helpdeskService.getFeedbackStatuses().subscribe((res: any) => {
      this.feedbackStatuses = res;
    }, err => {
      this.errorHandlerService.handleErorr(err);
    });
  }


  getAllRotations() {
    this.marketingService.getAllRotations().subscribe(
      (data: any) => {
        this.rotations = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getPcs() {
    this.userService.getPcs().subscribe(
      (data: any) => {
        this.pcs = data;
        this.searchedPcs = this.pcs;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getSubTeams() {
    this.userService.getSubTeams().subscribe(
      (data: any) => {
        this.teams = data;
        this.searchedTeams = this.teams;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getLeadStatus() {
    console.log("getLeadStatuses");
    this.leadsService.getLeadStatus().subscribe(
      (res: any) => {
        this.searchLeadsStatus = res;
        this.leadsStatus = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getNewLeadStatus() {
    this.leadsService.getLeadStatuses().subscribe(
      (res: any) => {
        if (res && res.leads_status && res.leads_status.length > 0) {
          let status = res.leads_status.find((a) => a.status == "New");
          if (status) this.newLeadCount = status.count;
        }
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  getAllReminders() {
    this.userService.getAllReminders().subscribe(
      (data: any) => {
        this.reminders = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getLeadReminder(id) {
    this.leadsService.getLeadReminder(id).subscribe(
      (res: any) => {
        this.lead_reminders = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  createFilterForm() {
    this.filterForm = this.fb.group({
      filter_name: [""],
      filter_consultant: [null],
      agent_ids: [[]],
      team_id: [null],
      filter_status: [null],
      filter_activity: [null],
      activity_all: [null],
      filter_channels: [null],
      filter_sources: [null],
      order_by: ["created_at"],
      interested_project_id: [null],
      campaign_id: [null],
      date_from: [null],
      date_to: [null],
      catch_from: [null],
      catch_to: [null],
      reminder: [null],
    });
  }

  getLeadRequests(id) {
    this.projectService.getLeadRequests(id).subscribe(
      (res: any) => {
        this.lead_requests = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getLeadsTickets(id) {
    this.leadsService.getLeadsTickets(id).subscribe(
      (res: any) => {
        this.tickets = res;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

    getTicketDescription(ticket: any): string {
    const desc = ticket.description || "-";
    return desc.length <= 20 ? desc : `${desc.slice(0, 20)}...`;
  }

  getLeads() {
    this.route.queryParams.subscribe((params) => {
      // this.reservation_id = +params['id'] || 0;
      console.log(params.status);
      if (params.status_id) {
        this.filterForm.get("filter_status").patchValue(params.status_name);
        if (params.channel) {
          console.log(JSON.parse(params.channel));
          let channel = JSON.parse(params.channel);
          this.filterForm.get("filter_channels").patchValue(channel);
        }
        console.log(this.filterForm.value);
        this.onFilterSubmit();
      } else if (params.lead_id) {
        this.getLeadDetails(params.lead_id);
      } else if (params.activity_name) {
        this.filterForm.get("activity_all").patchValue({
          name: params.activity_name,
        });
      }
      const leadId = this._route.snapshot.params["id"] || params.lead_id;
      console.log("this._route.snapshot.params", this._route.snapshot.params);

      this.onFilterSubmit(undefined, leadId);
      this.leadsCheckLastAndLoadNext();
    });
  }

  getAllProjects() {
    this.projectService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => {
        this.projects = data;
        this.searchedProjects = data;
        this.projects.unshift({ id: "", name: "All Projects" });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getAllCampaigns() {
    this.marketingService.getCampaigns({ paginate: false }).subscribe(
      (data: any) => {
        this.campaigns = data;
        this.searchedCampaigns = data;
        this.campaigns.unshift({ id: "", name: "All Campaigns" });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
        this.getLeadDetails(this.leadId);
      }
    );
  }

  onChannelChange(event) {
    this.searchedLeadChannels.map((channel) => {
      if (channel.id == event) {
        this.searchLeadSources = channel.sources;
      }
    })
  }

  onFilterSubmit(paginate_url?, leadId?) {
    this.loadingFilteredLeads = true;
    if (leadId) {
      this.leadsService.getLeads().subscribe(
        (respo: any) => {
          this.filteredLeads = respo.data;
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          console.log("getting leads from details id.....", leadId);
          this.getLeadDetails(leadId);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
        }
      );
    } else if (paginate_url) {
      let page_number = paginate_url.split("page=")[1];
      // console.log(page_number);
      this.formValue = this.filterForm.value;
      let agentVal = "";
      if (this.formValue.filter_consultant) {
        const consultantIndex = this.dataFromSearch.findIndex(
          (a) => a.name === this.formValue.filter_consultant
        );
        agentVal = this.dataFromSearch[consultantIndex].id;
      }
      this.slimLoadingBarService.start();
      const channelVal = this.formValue.filter_channels
        ? this.formValue.filter_channels
        : "";
      const params = {
        page: page_number,
        keyword: this.formValue.filter_name,
        // agent_id: agentVal,
        agent_ids: this.formValue.agent_ids,
        team_id: this.formValue["team_id"],
        status: this.formValue["filter_status"],
        activity: this.formValue["filter_activity"],
        lead_channel_id: channelVal,
        lead_source: this.formValue["filter_sources"],
        order_by: this.formValue.order_by ? this.formValue.order_by : "",
        interested_project_id: this.formValue["interested_project_id"],
        campaign_id: this.formValue["campaign_id"],
        date_from: this.formValue.date_from ? this.formValue.date_from : "",
        date_to: this.formValue.date_to ? this.formValue.date_to : "",
        catch_from: this.formValue.catch_from ? this.formValue.catch_from : "",
        catch_to: this.formValue.catch_to ? this.formValue.catch_to : "",
        activity_all: this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "",
        reminder: this.formValue.reminder ? this.formValue.reminder : "",
      };
      params.agent_ids && (params.agent_ids = params.agent_ids.join(","));
      this.leadsService.getLeads(params).subscribe(
        (respo: any) => {
          this.filteredLeads = this.filteredLeads.concat(respo.data);
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.loadingFilteredLeads = false;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.loadingFilteredLeads = false;
        }
      );
    } else {
      this.filterSubmitDisabled = true;
      this.formValue = this.filterForm.value;
      let agentVal = "";
      if (this.formValue.filter_consultant) {
        const consultantIndex = this.dataFromSearch.findIndex(
          (a) => a.name === this.formValue.filter_consultant
        );
        agentVal = this.dataFromSearch[consultantIndex].id;
      }
      this.slimLoadingBarService.start();
      const channelVal = this.formValue.filter_channels
        ? this.formValue.filter_channels
        : "";
      console.log(this.formValue);
      const params = {
        keyword: this.formValue.filter_name,
        // agent_id: agentVal,
        agent_ids: this.formValue.agent_ids,
        team_id: this.formValue["team_id"],
        status: this.formValue["filter_status"],
        activity: this.formValue["filter_activity"],
        lead_channel_id: channelVal,
        lead_source: this.formValue["filter_sources"],
        order_by: this.formValue.order_by ? this.formValue.order_by : "",
        interested_project_id: this.formValue["interested_project_id"],
        campaign_id: this.formValue["campaign_id"],
        date_from: this.formValue.date_from ? this.formValue.date_from : "",
        date_to: this.formValue.date_to ? this.formValue.date_to : "",
        catch_from: this.formValue.catch_from ? this.formValue.catch_from : "",
        catch_to: this.formValue.catch_to ? this.formValue.catch_to : "",
        activity_all: this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "",
        reminder: this.formValue.reminder ? this.formValue.reminder : "",
      };
      params.agent_ids && (params.agent_ids = params.agent_ids.join(","));
      this.leadsService.getLeads(params).subscribe(
        (respo: any) => {
          this.filteredLeads = respo.data;
          this.leadsTotal = respo.total;

          //Set new key for checkbox
          this.setKeyForCheckbox();

          this.next_page_url = respo.next_page_url;
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          if (respo.data.length !== 0) {
            this.getLeadDetails(this.filteredLeads[0].id);
          }
          this.loadingFilteredLeads = false;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
          this.filterSubmitDisabled = false;
          this.loadingFilteredLeads = false;
        }
      );
    }
  }

  onReset() {
    this.filterForm.reset();
    this.filterForm.patchValue({
      order_by: "updated_at",
    });
    this.onFilterSubmit();
  }

  getAllActions() {
    this.slimLoadingBarService.start();
    this.userService.getAllActivites().subscribe(
      (data: any) => {
        this.actions = [...data];
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
    this.userService.getAllActivitesForLeadsFilter().subscribe(
      (data: any) => {
        this.activitiesForFilter = [...data];
        this.searchedActivitiesForFilter = this.activitiesForFilter;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  valueChanged(ev) {
    this.chosenAgent = ev;
  }

  leadSource() {
    this.leadSources = null;
    const data = this.leadsService.leadSource();
    this.leadSources = data;
  }

  createForm() {
    this.documentForm = this.fb.group({
      type: [null, Validators.required],
      value: [null, Validators.required],
      value_date: [null],
      image: [null],
      is_residence: ["false", Validators.required],
      residence_image: [null],
      residence_name: [null],
    });

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  get is_residence() {
    return this.documentForm.get("is_residence").value;
  }

  handleUploadExcel(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadExcel.get("file").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  uploadExcelMethod(modal) {
    const formModel = this.uploadExcel.value;
    if (!formModel.file) {
      swal("Oops...", "Files can not be empty!", "error");
      return;
    } else {
      const data: any = {
        file: formModel.file.value,
        file_name: formModel.file.filename,
        rotation_id: this.rotation_id,
        user_ids: this.user_ids,
      };
      if (this.assign_type == "rotation") {
        delete data.user_ids;
      } else {
        delete data.rotation_id;
      }

      this.slimLoadingBarService.start();
      this.uploadExcelUtility(data, modal);
    }
  }

  uploadExcelUtility(data, modal) {
    this.leadsService.uploadLeadsExcel(data).subscribe(
      (response) => {
        modal.close();
        this.onFilterSubmit();
        this.slimLoadingBarService.complete();
        swal("Woohoo!", "Files uploaded succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.documentForm.get("image").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  onResidenceChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.documentForm
          .get("residence_image")
          .patchValue((reader.result as any as any).split(",")[1]);
        this.documentForm.get("residence_name").patchValue(file.name);
      };
    }
  }

  onDocumentSubmit() {
    this.slimLoadingBarService.start();
    const formModel = this.documentForm.value;
    if (!formModel.image) {
      swal("Oops...", "No file chosen", "error");
    } else {
      const data = {
        type: formModel.type,
        value: formModel.value,
        value_date: formModel.value_date,
        file_name: this.file_name,
        is_residence: formModel.is_residence,
        residence_image: formModel.residence_image,
        residence_name: formModel.residence_name,
      };
      if(formModel.image){
        data['image'] = formModel.image.value;
      }

      this.leadsService.postDocument(data, this.leadId).subscribe(
        (response) => {
          this.slimLoadingBarService.complete();
          this.createForm();
          swal("Woohoo!", "Document updated succesfully!", "success");
          this.getLeadDetails(this.leadId);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
    }
  }

  SmSgroupSendMethod(modal) {
    const payload = this.smsgroup.value;
    if (!this.smsgroup.valid) {
      swal("All Fields are required", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.marketingService.sendBulkSmSByStatus(payload).subscribe(
        (res: any) => {
          modal.close();
          this.onFilterSubmit();
          swal("Bulk Messages sent successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  getMoreLeads() {
    if (this.next_page_url) {
      this.getNextLead();
    }
  }

  getNextLead() {
    this.onFilterSubmit(this.next_page_url);
  }

  addAction(modal) {
    this.slimLoadingBarService.start();
    this.activity.leadId = this.leadId;
    const data = {
      title: this.activity.actionName,
      details: this.activity.actionDescription,
      status: this.activity.status,
      reminder_datetime: this.activity.reminder_datetime,
    };
    this.leadsService.addLeadActivity(this.leadDetails["id"], data).subscribe(
      (res) => {
        this.activity.actionName = "";
        this.activity.actionDescription = "";
        this.getLeadDetails(this.leadId);
        this.slimLoadingBarService.complete();
        this.activity.actionName = null;
        this.activity.actionDescription = "";
        this.activity.reminder_datetime = null;
        this.getNewLeadStatus();
        this.onFilterSubmit(this.next_page_url ? this.next_page_url : null);
        modal.close();
        swal("Woohoo!", "Action created succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getStatus() {
    this.status = null;
    this.status = this.leadsService.status();
  }

  changeStatus(modal) {
    this.slimLoadingBarService.start();

    const data = {
      status: this.lstatus.status,
      reason: this.lstatus.changeResaon,
      reminder_datetime: this.lstatus.status_reminder_datetime,
    };

    this.leadsService.changeLeadStatus(this.leadDetails["id"], data).subscribe(
      (respo) => {
        this.getLeadDetails(this.leadId);
        // this.getLeads();
        // this.onFilterSubmit();
        this.filteredLeads.forEach((lead, index) => {
          if (lead.id == this.leadDetails.id) {
            this.filteredLeads[index].status = this.lstatus.status;
          }
        });
        this.getNewLeadStatus();
        modal.close();
        swal("Woohoo!", "Lead status updated succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  assignCopy() {
    this.filteredLeads = Object.assign([], this.leads);
  }

  getLeadDetails(id) {
    if (isNaN(id)) {
      console.error(
        "tried to use getLeadDetails(id), but the id wasn't a number\nData recieved:",
        id
      );

      return;
    }
    this.leadId = id;
    this.selectedLead = id;
    this.slimLoadingBarService.start();
    this.leadsService.getLeadDetails(id).subscribe(
      (data: any) => {
        this.getLeadReminder(this.leadId);
        console.log(data);
        this.getLeadRequests(id);
        this.getLeadPhoneLogsAction(id);
        this.getLeadMeetingsAction(id);
        this.getMessagesLogsAction(id);
        this.getLeadsTickets(id);
        this.leadDetails = data.lead;
        this.initializingAgentSelection = true;
        const assignedAgents = Array.isArray(data.lead.agents)
          ? data.lead.agents
          : data.lead.agent
          ? [data.lead.agent]
          : [];
        this.selectedAgentIds = assignedAgents
          .map((agent: any) =>
            typeof agent === "number" ? agent : agent && agent.id ? agent.id : null
          )
          .filter((id) => id !== null && id !== undefined);
        this.leadDetails.agent_ids = [...this.selectedAgentIds];
        this.leadDetails.agent_id = this.selectedAgentIds.length
          ? this.selectedAgentIds[0]
          : null;
        this.lstatus.status = data.lead ? data.lead.status : null;
        this.leadActivities = data.activities;
        this.leadId = data.lead.id;
        this.interest_project = data.lead;
        if (this.leadDetails.national_url && this.leadDetails.passport_url) {
          this.imagesArray = [
            new Image(this.leadDetails.national_url),
            new Image(this.leadDetails.passport_url),
          ];
        } else if (
          this.leadDetails.national_url &&
          !this.leadDetails.passport_url
        ) {
          this.imagesArray = [new Image(this.leadDetails.national_url)];
        } else if (
          !this.leadDetails.national_url &&
          this.leadDetails.passport_url
        ) {
          this.imagesArray = [new Image(this.leadDetails.passport_url)];
        } else if (
          !this.leadDetails.national_url &&
          !this.leadDetails.passport_url
        ) {
          this.imagesArray = [];
        }
        if (this.leadDetails.residence_url) {
          this.imagesArray.push(new Image(this.leadDetails.residence_url));
        }
        Promise.resolve().then(() => {
          this.initializingAgentSelection = false;
        });
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.initializingAgentSelection = false;
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getActivityDetails(heading) {
    for (let key in this.leadActivities) {
      if (key == heading) {
        const arr = this.leadActivities[heading];
        return arr;
      }
    }
  }

  filterLeadObservable = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  observableSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getAgents() {
    this.slimLoadingBarService.start();
    this.agents = null;
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        if (!this.userData.is_sales_team) {
          this.agents.forEach((element) => {
            this.agentsArrayString.push(element.name);
          });
        }
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  deleteLead(id) {
    this.slimLoadingBarService.start();
    this.leadsService.delete(id).subscribe(
      (data) => {
        swal("Deleted!", "deleted lead successfully!", "success");
        this.slimLoadingBarService.complete();
        this.leadDetails = null;
        let lead_index;
        this.filteredLeads.forEach((lead, index) => {
          if (lead.id == id) {
            lead_index = index;
          }
        });
        if (lead_index) {
          this.filteredLeads.splice(lead_index, 1);
        }
        this.onFilterSubmit();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  // confirm(title: string, body: string, confirm: () => any, cancel: () => any) {
  //   this.modal
  //     .confirm().size('sm')
  //     .okBtnClass("btn btn-xs btn-info").cancelBtnClass("btn btn-xs btn-info")
  //     .okBtn("Yes").cancelBtn("No")
  //     .title(title).body(body)
  //     .open().then(val => { val.result.then(res => confirm(), res => cancel()) });
  // }

  notifySuccess(message: string) {
    this.notify(message, "success");
  }

  notifyError(message: string) {
    this.notify(message, "danger");
  }

  notify(message: string, status: string) {
    Messenger().post({
      message: message,
      type: status,
      hideAfter: 5,
      singleton: true,
    });
  }

  editLead(leadId) {
    this.router.navigate(["./pages/addLead", leadId]);
  }

  getDocumnetTypes() {
    this.documentTypes = null;
    this.documentTypes = this.leadsService.getDocumnetTypes();
    this.documentType = "Passport";
  }

  confirmLeadDocument() {}

  getLeadDocuments(id) {
    this.leadDocuments = this.leadsService.geLeadDocuments(id);
  }

  assignToAgent() {
    const previousAgentIds =
      this.leadDetails && Array.isArray(this.leadDetails.agent_ids)
        ? [...this.leadDetails.agent_ids]
        : [];
    const agentIds = (this.selectedAgentIds || []).filter(
      (id) => id !== null && id !== undefined
    );
    if (!agentIds.length) {
      this.initializingAgentSelection = true;
      this.selectedAgentIds = [...previousAgentIds];
      Promise.resolve().then(() => {
        this.initializingAgentSelection = false;
      });
      swal("Error", "Please select at least one agent", "error");
      return;
    }
    this.leadDetails.agent_ids = [...agentIds];
    this.leadDetails.agent_id = agentIds[0] || null;
    const payload = {
      agent_ids: agentIds,
    };
    this.slimLoadingBarService.start();
    this.leadsService.assignALead(this.leadId, payload).subscribe(
      (data) => {
        this.getLeadDetails(this.leadId);
        this.slimLoadingBarService.complete();
        swal(
          "Cool!",
          "Lead assigned to new property consultant succesfully!",
          "success"
        );
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onAgentsSelectionChange(agentIds: number[]) {
    this.selectedAgentIds = (agentIds || []).filter(
      (id) => id !== null && id !== undefined
    );
    if (this.initializingAgentSelection) {
      return;
    }
    this.assignToAgent();
  }

  exportLead() {
    this.slimLoadingBarService.start();
    this.leadsService.exportLeads().subscribe(
      (data: any) => {
        window.open(data);
        swal("Cool!", "Leads has been exported succesfully!", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  createSmSgroupForm() {
    this.smsgroup = this.fb.group({
      lead_status: ["", Validators.required],
      message: ["", Validators.required],
    });
  }
  createSmSBulkForm() {
    this.smsForm = this.fb.group({
      lead_id: ["", Validators.required],
      message: ["", Validators.required],
      phone: ["", Validators.required],
    });
  }

  createEmailBulkForm() {
    this.emailForm = this.fb.group({
      lead_id: ["", Validators.required],
      subject: ["", Validators.required],
      message: ["", Validators.required],
    });
  }
  openSMSgroupModal(modal) {
    this.createSmSgroupForm();
    modal.open();
  }
  openEmailModal(modal) {
    this.createEmailBulkForm();
    this.emailForm.patchValue({
      lead_id: this.leadDetails.id,
    });
    modal.open();
  }

  openSmMModal(modal) {
    this.createSmSBulkForm();
    this.smsForm.patchValue({
      lead_id: this.leadDetails.id,
      phone: this.leadDetails.phone,
    });
    modal.open();
  }
  SmSgroupFormModalOnClose() {
    this.createSmSgroupForm();
  }
  smsModalOnClose() {
    this.createSmSBulkForm();
  }

  emailModalOnClose() {
    this.createEmailBulkForm();
  }

  sendSmSBulk(modal) {
    const payload = this.smsForm.value;
    if (!this.smsForm.valid) {
      swal("All Fields are required", "", "error");
    } else {
      this.slimLoadingBarService.start();
      this.marketingService.sendSingleSmS(payload).subscribe(
        (res: any) => {
          modal.close();
          this.getLeadDetails(payload.lead_id);
          swal("Message send successfully", "", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  sendEmailBulk(modal) {
    const payload = this.emailForm.value;
    if (!this.emailForm.valid) {
      swal("All Fields are required", "", "error");
    } else {
      swal("Send Email is disabled", "", "info");
      // this.slimLoadingBarService.start();
      // this.marketingService.sendSingleEmail(payload).subscribe(
      //   (res: any) => {
      //     modal.close();
      //     this.getLeadDetails(payload.lead_id);
      //     swal("Email Sent successfully", "", "success");
      //   },
      //   (err) => this.errorHandlerService.handleErorr(err),
      //   () => this.slimLoadingBarService.complete()
      // );
    }
  }

  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  channelChange(ev) {
    this.channels.forEach((e) => {
      if (e.name == this.channel) {
        this.leadSources = [];
        this.leadSources = e.sources;
      }
    });
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  brokerChange(value) {
    const payload = {
      lead_id: this.leadDetails.id,
      broker_id: value,
    };
    this.slimLoadingBarService.start();
    this.leadsService.updateLeadBroker(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        swal("Broker assigned to the lead successfully.", "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  exportFilter() {
    this.formValue = this.filterForm.value;
  }

  export() {
    this.slimLoadingBarService.start();
    this.leadsService.exportLeads().subscribe(
      (res: any) => {
        this.channels = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  exportFillteredLeads() {
    this.formValue = this.filterForm.value;
    let agentVal = "";
    if (this.formValue.filter_consultant) {
      const consultantIndex = this.dataFromSearch.findIndex(
        (a) => a.name === this.formValue.filter_consultant
      );
      agentVal = this.dataFromSearch[consultantIndex].id;
    }
    this.slimLoadingBarService.start();
    const channelVal = this.formValue.filter_channels
      ? this.formValue.filter_channels
      : "";
    const fromDateVal = this.formValue.date_from
      ? this.formValue.date_from
      : "";
    const toDateVal = this.formValue.date_to ? this.formValue.date_to : "";
    const fromCatchVal = this.formValue.catch_from
      ? this.formValue.catch_from
      : "";
    const toCatchVal = this.formValue.catch_to ? this.formValue.catch_to : "";
    const reminder = this.formValue.reminder ? this.formValue.reminder : "";

    const params = {
      keyword: this.formValue.filter_name,
      // agent_id: agentVal,
      agent_ids: this.formValue.agent_ids,
      team_id: this.formValue["team_id"],
      status: this.formValue["filter_status"],
      activity: this.formValue["filter_activity"],
      lead_channel_id: channelVal,
      lead_source: this.formValue.filter_sources,
      interested_project_id: this.formValue["interested_project_id"],
      campaign_id: this.formValue["campaign_id"],
      order_by: this.formValue.order_by ? this.formValue.order_by : "",
      date_from: fromDateVal,
      date_to: toDateVal,
      catch_from: fromCatchVal,
      catch_to: toCatchVal,
      reminder: reminder,
      is_export: 1,
    };
    params.agent_ids && (params.agent_ids = params.agent_ids.join(","));
    this.leadsService.getLeads(params).subscribe(
      (data: any) => {
        // this.searchLeadSources = data;
        console.log(data);
        window.open(data.url);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  addAdminComent(modal) {
    console.log(this.adminComment);
    let payload = {
      admin_comment: this.adminComment,
    };
    this.slimLoadingBarService.start();
    this.http
      .put(
        `${environment.api_base_url}leads/${this.leadId}/admin_comment`,
        JSON.stringify(payload)
      )
      .subscribe(
        (res: any) => {
          swal("success", "added admin comment successfully", "success");
          this.slimLoadingBarService.complete();
          this.adminComment = this.leadDetails.admin_comment;
          modal.close();
        },
        (err) => {
          console.log(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  addRequest() {
    console.log(this.request);
    let payload = {
      project_id: this.request.project_id,
      unit_type_id: this.request.unit_type,
      country: this.request.country,
      governorate: this.request.governorate,
      district: this.request.district,
      delivery_date: this.request.delivery_date,
      budget_from: this.request.total_budget_from,
      budget_to: this.request.total_budget_to,
      down_payment_from: this.request.down_payment_from,
      down_payment_to: this.request.down_payment_to,
      installments_from: this.request.monthly_installments_from,
      installments_to: this.request.monthly_installments_to,
      unit_area_from: this.request.unit_area_from,
      unit_area_to: this.request.unit_area_to,
    };
    this.slimLoadingBarService.start();
    this.projectService.addLeadRequest(this.leadDetails.id, payload).subscribe(
      (res: any) => {
        this.getLeadRequests(this.leadDetails.id);
        this.slimLoadingBarService.complete();
        this.request = new LeadRequest();
        swal("Sucecss", "Added request successfully", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  onProjectChange(event) {
    console.log(this.request.project_id);
    this.getUnitTypes(this.request.project_id);
  }

  getUnitTypes(project_id) {
    this.slimLoadingBarService.start();
    this.projectService.getUnitTypes(project_id).subscribe(
      (data) => {
        this.types = data;
        console.log(this.types);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  leadHadMeeting() {
    swal({
      title: "Are you sure?",
      text: "indoor a meeting!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reserve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.leadsService.indoorMeeting(this.leadDetails.id).subscribe(
          (data) => {
            console.log(data);
            swal("success", "Indoor Meeting successfully", "success");
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  addReminder() {
    this.slimLoadingBarService.start();
    const data = {
      title: this.reminder.title,
      details: this.reminder.details,
      reminder_datetime: this.reminder.reminder_datetime,
    };
    console.log(data);
    this.leadsService.addLeadReminder(this.leadDetails["id"], data).subscribe(
      (res) => {
        this.reminder = {
          title: null,
          details: null,
          reminder_datetime: null,
        };
        this.getLeadReminder(this.leadId);
        this.slimLoadingBarService.complete();
        swal("Woohoo!", "Reminder created succesfully!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onReminderChange(event, rem) {
    this.slimLoadingBarService.start();
    this.leadsService.toggleReminderRead(rem.id).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  //Set new key for checkbox
  setKeyForCheckbox() {
    this.filteredLeads.forEach((element) => {
      if (this.allChecked == true) {
        element.checked = true;
      } else {
        element.checked = false;
      }
    });
    this.updateSelectedCount();
  }

  updateAllComplete() {
    this.allChecked =
      this.filteredLeads != null &&
      this.filteredLeads.every((lead) => lead.checked);
    this.updateSelectedCount();
  }

  someComplete(): boolean {
    if (this.filteredLeads == null) {
      return false;
    }
    return (
      this.filteredLeads.filter((lead) => lead.checked).length > 0 &&
      !this.allChecked
    );
  }

  setAll(checked: boolean) {
    this.allChecked = checked;

    if (this.filteredLeads == null) {
      return;
    }
    this.filteredLeads.forEach((lead) => (lead.checked = checked));
    this.updateSelectedCount();
  }

  selectAllLeads(checked: boolean) {
    this.disableCheckbox = checked;
    this.allLeadsChecked = checked;

    if (this.filteredLeads == null) {
      return;
    }
    this.allChecked = false;
    this.filteredLeads.forEach((lead) => (lead.checked = false));

    if (checked) {
      this.selectedLeadsCount = this.leadsTotal;
      this.reassignLeadsPayload.select_all = true;
    } else {
      this.selectedLeadsCount = 0;
      this.reassignLeadsPayload.select_all = false;
      this.setNull(this.reassignLeadsPayload);
    }
  }

  updateSelectedCount() {
    this.selectedLeadsCount = this.filteredLeads.filter(
      (lead) => lead.checked == true
    ).length;
  }

  reassignLeadsModalOpen(modal) {
    this.selectedLeadsID = this.filteredLeads
      .filter((lead) => lead.checked == true)
      .map((lead) => lead.id);
    this.reassignLeadsPayload.leads_ids = this.selectedLeadsID;

    if (this.disableCheckbox) {
      this.reassignLeadsPayload = {
        ...this.reassignLeadsPayload,
        ...this.formValue,
      };
    }

    console.log(this.reassignLeadsPayload);

    if (
      this.selectedLeadsID.length < 1 &&
      !this.reassignLeadsPayload.select_all
    ) {
      swal({
        title: "There is no selected leads",
        text: "You have to select leads first!!",
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "Go, select leads first!",
      }).then((result) => {
        modal.close();
      });
    }
  }

  reassignLeadsModalClose(modal) {
    this.setNull(this.reassignLeadsPayload);
    modal.close();
  }

  reassignLeadsModalSubmit(modal) {
    if (
      !this.reassignLeadsPayload.reassign_user_id &&
      !this.reassignLeadsPayload.rotation_id
    ) {
      swal("Please select agent and rotation", "", "error");
      return;
    }
    swal({
      title: "Are you sure?",
      text: "You are about to do an actions over multiple leads!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Do it!",
      cancelButtonText: "No.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.formValue = this.filterForm.value;
        let agentVal = "";
        if (this.formValue.filter_consultant) {
          const consultantIndex = this.dataFromSearch.findIndex(
            (a) => a.name === this.formValue.filter_consultant
          );
          agentVal = this.dataFromSearch[consultantIndex].id;
        }
        // this.reassignLeadsPayload.agent_id = agentVal;
        this.slimLoadingBarService.start();
        console.log(this.formValue.filter_status);
        // this.reassignLeadsPayload.status =
        //   this.formValue.filter_status && this.formValue.filter_status.length
        //     ? this.formValue.filter_status.map((el) => el).join(",")
        //     : "";
        this.reassignLeadsPayload.status = this.formValue.filter_status
          ? this.formValue.filter_status
          : "";
        // this.reassignLeadsPayload.activity =
        //   this.formValue.filter_activity &&
        //   this.formValue.filter_activity.length
        //     ? this.formValue.filter_activity.map((el) => el).join(",")
        //     : "";
        this.reassignLeadsPayload.activity = this.formValue.filter_activity
          ? this.formValue.filter_activity
          : "";

        this.reassignLeadsPayload.lead_channel_id = this.formValue
          .filter_channels
          ? this.formValue.filter_channels
          : "";

        // this.reassignLeadsPayload.lead_source =
        //   this.formValue.filter_sources && this.formValue.filter_sources.length
        //     ? this.formValue.filter_sources.map((el) => el.name).join(",")
        //     : "";
        this.reassignLeadsPayload.lead_source = this.formValue.filter_sources
          ? this.formValue.filter_sources
          : "";
        this.reassignLeadsPayload.lead_event_id = this.formValue.lead_event_id
          ? this.formValue.lead_event_id.id
          : "";
        this.reassignLeadsPayload.qualified_feedback_status = this.formValue
          .qualified_feedback_status
          ? this.formValue.qualified_feedback_status.id
          : "";

        this.reassignLeadsPayload.lead_campaign_id = this.formValue
          .lead_campaign_id
          ? this.formValue.lead_campaign_id
          : "";

        this.reassignLeadsPayload.team_id = this.formValue.team_id
          ? this.formValue.team_id.id
          : "";
        this.reassignLeadsPayload.interested_project_id = this.formValue
          .interested_project_id
          ? this.formValue.interested_project_id
          : "";
        this.reassignLeadsPayload.campaign_id = this.formValue.campaign_id
          ? this.formValue.campaign_id
          : "";
        this.reassignLeadsPayload.date_from = this.formValue.date_from
          ? this.formValue.date_from
          : "";
        this.reassignLeadsPayload.date_to = this.formValue.date_to
          ? this.formValue.date_to
          : "";
        this.reassignLeadsPayload.catch_from = this.formValue.catch_from
          ? this.formValue.catch_from
          : "";
        this.reassignLeadsPayload.catch_to = this.formValue.catch_to
          ? this.formValue.catch_to
          : "";
        this.reassignLeadsPayload.reminder = this.formValue.reminder
          ? this.formValue.reminder
          : "";
        this.reassignLeadsPayload.keyword = this.formValue.filter_name;
        this.reassignLeadsPayload.activity_all = this.formValue.activity_all
          ? this.formValue.activity_all.name
          : "";
        for (let key in this.reassignLeadsPayload) {
          if (this.reassignLeadsPayload[key] == null)
            delete this.reassignLeadsPayload[key];
        }
        if (this.assign_type == "agent") {
          delete this.reassignLeadsPayload.rotation_id;
        } else {
          delete this.reassignLeadsPayload.reassign_user_id;
        }
        delete this.reassignLeadsPayload.order_by;
        this.leadsService.reassignAllLeads(this.reassignLeadsPayload).subscribe(
          (data) => {
            this.allLeadsChecked = false;
            this.selectAllLeads(false);

            //Set all object key to null after submission
            this.setNull(this.reassignLeadsPayload);

            modal.close();

            this.getLeads();

            this.slimLoadingBarService.complete();

            swal(
              "Cool!",
              "Leads assigned to new agent succesfully!",
              "success"
            );
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.reset();
          },
          () => this.slimLoadingBarService.complete()
        );
      }
    });
  }

  //Set all object key to null after submission #45897879 stackoverflow
  setAllKeys(obj, val) {
    Object.keys(obj).forEach(function (index) {
      obj[index] = val;
    });
  }

  setNull(obj) {
    this.setAllKeys(obj, null);
  }

  // leads scroll

  ngAfterViewInit() {
    this.leadsContainer.nativeElement.addEventListener(
      "scroll",
      this.leadsCheckLastAndLoadNext.bind(this)
    );
  }

  leadsCheckLastAndLoadNext() {
    if (
      !this.loadingFilteredLeads &&
      this.leadsContainer.nativeElement.scrollHeight -
        this.leadsContainer.nativeElement.scrollTop -
        this.leadsContainer.nativeElement.clientHeight <
        10 &&
      this.next_page_url
    ) {
      this.getMoreLeads();
    }
  }

  searchLeadsStatusHandler(searchLeadsStatusInput) {
    this.leadsStatus = this.searchLeadsStatus.filter((status) => {
      return status
        .toLowerCase()
        .includes(searchLeadsStatusInput.toLowerCase());
    });
  }

  searchPcsHandler(searchPcsInput) {
    this.searchedPcs = this.pcs.filter((pc) => {
      return pc.name.toLowerCase().includes(searchPcsInput.toLowerCase());
    });
  }

  searchTeamsHandler(searchPcsInput) {
    this.searchedTeams = this.teams.filter((team) => {
      return team.name.toLowerCase().includes(searchPcsInput.toLowerCase());
    });
  }

  searchLeadChannelsHandler(searchLeadChannelInput) {
    this.searchedLeadChannels = this.channels.filter((channel) => {
      return channel.name
        .toLowerCase()
        .includes(searchLeadChannelInput.toLowerCase());
    });
  }

  searchLeadSourcesHandler(searchLeadSourceInput) {
    this.searchedLeadSources = this.searchLeadSources.filter((source) => {
      return source.name
        .toLowerCase()
        .includes(searchLeadSourceInput.toLowerCase());
    });
  }

  searchProjectsHandler(searchProjectInput) {
    this.searchedProjects = this.projects.filter((project) => {
      return project.name
        .toLowerCase()
        .includes(searchProjectInput.toLowerCase());
    });
  }

  searchOrderTypesHandler(searchOrderTypeInput) {
    this.searchedOrderTypes = this.orderTypes.filter((orderType) => {
      return orderType.name
        .toLowerCase()
        .includes(searchOrderTypeInput.toLowerCase());
    });
  }

  searchCampaignsHandler(searchCampaignInput) {
    this.searchedCampaigns = this.campaigns.filter((campaign) => {
      return campaign.name
        .toLowerCase()
        .includes(searchCampaignInput.toLowerCase());
    });
  }

  searchActivityHandler(searchActivityInput) {
    this.searchedActivitiesForFilter = this.activitiesForFilter.filter(
      (activity) => {
        return activity
          .toLowerCase()
          .includes(searchActivityInput.toLowerCase());
      }
    );
  }

  private toLocalDatetimeLocal(isoOrDate: string | Date): string {
    const d = isoOrDate instanceof Date ? isoOrDate : new Date(isoOrDate);
    // HTML datetime-local ignores seconds; trim them for cleanliness
    d.setSeconds(0, 0);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  setMeetingModalOpen() {
    const existing = new Date();
    this.setMeeting = this.setMeeting || {};
    if(!this.setMeeting.due_date) {
      this.setMeeting.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInSetMeeting = false;
    this.setMeeting.feedback_status_id = null;
    this.setMeeting.event_status_id = null;
    this.setMeeting.feedback = null;
  }

  logPhoneCallModalOpen() {
    const existing = new Date();
    this.logPhoneCall = this.logPhoneCall || {};
    if(!this.logPhoneCall.due_date){
      this.logPhoneCall.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInLogPhoneCall = false;
    this.logPhoneCall.feedback_status_id = null;
    this.logPhoneCall.event_status_id = null;
    this.logPhoneCall.feedback = null;
  }

  logMassageModalOpen() {
    const existing = new Date();
    this.logMessage = this.logMessage || {};
    if(!this.logMessage.due_date){
      this.logMessage.due_date = this.toLocalDatetimeLocal(existing);
    }
    // Reset feedback visibility and clear feedback fields
    this.showFeedbackInLogMessage = false;
    this.logMessage.feedback_status_id = null;
    this.logMessage.event_status_id = null;
    this.logMessage.feedback = null;
  }

  nextActionModalOpen() {
    const existing = new Date();
    this.nextAction = this.nextAction || {};
    this.nextAction.next_action_due_date = this.toLocalDatetimeLocal(existing);
  }

  openEditMeetingModal(modal: any, meeting: any) {
    this.setMeeting = {
      action_type: "meeting",
      meeting_type_id: meeting.meeting_type_id,
      due_date: meeting.due_date,
      event_type_id: meeting.event_type_id,
      event_status_id: meeting.event_status_id,
      notes: meeting.notes,
      has_next_action: false
    }
    modal.open()
  }

  openEditPhoneLogModal(modal: any, phoneLog: any) {
    this.logPhoneCall = {
      action_type: "call",
      lead_action_id: phoneLog.id,
      call_type_id: phoneLog.call_type_id,
      due_date: phoneLog.due_date,
      notes: phoneLog.notes,
      has_next_action: false
    }
    modal.open()
  }

  openEditMessageLogModal(modal: any, messageLog: any) {
    this.logMessage = removeNullishFieldsParams(messageLog);
    this.logMessage = {
      action_type: "message",
      message_source_id: messageLog.message_source_id,
      due_date: messageLog.due_date,
      notes: messageLog.notes,
      has_next_action: false
    }
    modal.open()
  }

  editAction(modal: any, nextActionModal: any, modalData: any, has_first_action?: boolean) {
    // Validate feedback fields for past dates
    if (modalData.due_date && this.isPastDate(modalData.due_date)) {
      if (!modalData.feedback_status_id) {
        swal("Validation Error", "Feedback Status is required for past actions", "error");
        return;
      }
    }

    // Prepare payload - includes feedback fields (feedback_status_id, event_status_id, feedback) for past actions
    let payload;
    if(has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      this.leadsService.editAction(this.leadDetails['id'], payload.lead_action_id, payload).subscribe((res :any) => {
        swal(res.message, "", "success");
        modal.close();
        if (isFutureDateTime(payload.due_date)) {
          this.reminder.title = payload.action_type;
          this.reminder.lead_action_id = res.action_type.id
          this.reminder.details = payload.notes;
          this.reminder.reminder_datetime = payload.due_date;
          this.addReminder();
        };
        this.edit_action_mode = false;
        this.getLeadDetails(this.lead_id)
      }, (err) => {
        this.errorHandlerService.handleErorr(err);
      })
    }
  }

  setActionModalSubmit(modal: any, nextActionModal: any, modalData: any, has_first_action?: boolean) {
    console.log('modalData:', modalData);
    console.log(modalData.due_date);
    console.log(this.isPastDate(modalData.due_date));
    // Validate feedback fields for past dates
    if (modalData.due_date && this.isPastDate(modalData.due_date)) {
      if (!modalData.feedback_status_id) {
        swal("Validation Error", "Feedback Status is required for past actions", "error");
        return;
      }
    }

    // Prepare payload - includes feedback fields (feedback_status_id, event_status_id, feedback) for past actions
    let payload;
    if(has_first_action) {
      payload = {
        ...this.firstAction,
        ...modalData
      };
    } else {
      payload = modalData;
    }
    console.log(payload);
    if (modalData.has_next_action) {
      this.firstAction = modalData;
      modal.close();
      nextActionModal.open();
    } else {
      this.leadsService.setAction(this.leadDetails["id"], payload).subscribe(
        (res: any) => {
          modal.close();
          swal(res.message, "", "success");
          res.lead_action.lead_id && this.getLeadDetails(res.lead_action.lead_id);
          console.log(isFutureDateTime(payload.due_date))
          if(isFutureDateTime(payload.due_date)) {
            this.reminder.title = payload.action_type;
            this.reminder.lead_action_id = res.lead_action.id
            this.reminder.details = payload.notes;
            this.reminder.reminder_datetime = payload.due_date;
            this.addReminder();
          }
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
    }
  }

  getLeadMeetingsAction(lead_id: number){
    this.leadsService.getActions(lead_id, 'meeting').subscribe((res: any)=>{
      this.meetings = res.actions;
    }, (err: any) => {
      this.errorHandlerService.handleErorr(err)
    })
  }

  getLeadPhoneLogsAction(lead_id: number){
    this.leadsService.getActions(lead_id, 'call').subscribe((res: any)=>{
      this.phoneLogs = res.actions;
    }, (err: any) => {
      this.errorHandlerService.handleErorr(err)
    })
  }

  getMessagesLogsAction(lead_id: number){
    this.leadsService.getActions(lead_id, 'message').subscribe((res: any)=>{
      this.messagesLogs = res.actions;
    }, (err: any) => {
      this.errorHandlerService.handleErorr(err)
    })
  }

  openWhatsAppAndLogMessage(phoneNumber: string) {
    this.edit_action_mode = false;
    this.lead_id = this.leadDetails.id;
    this.logMessageModal.open();
    window.open('https://wa.me/' + phoneNumber, '_blank');
  }

  openPhoneAndLogCall(phoneNumber: string) {
    this.edit_action_mode = false;
    this.lead_id = this.leadDetails.id;
    this.logPhoneCallModal.open();
    window.open('tel:' + phoneNumber, '_blank');
  }

  // Helper method to check if a date is in the past
  isPastDate(dateString: string): boolean {
    if (!dateString || dateString === null || dateString === undefined) {
      return false;
    }
    try {
      return !this.isFutureDateTime(dateString);
    } catch (error) {
      console.error('Error checking if date is in past:', error);
      return false;
    }
  }

  // Date change handlers for modals
  onSetMeetingDateChange() {
    if (!this.setMeeting || !this.setMeeting.due_date) {
      this.showFeedbackInSetMeeting = false;
      return;
    }

    this.showFeedbackInSetMeeting = this.isPastDate(this.setMeeting.due_date);
    if (!this.showFeedbackInSetMeeting) {
      // Clear feedback fields when switching to future date
      this.setMeeting.feedback_status_id = null;
      this.setMeeting.event_status_id = null;
      this.setMeeting.feedback = null;
    }
  }

  onLogPhoneCallDateChange() {
    if (!this.logPhoneCall || !this.logPhoneCall.due_date) {
      this.showFeedbackInLogPhoneCall = false;
      return;
    }

    this.showFeedbackInLogPhoneCall = this.isPastDate(this.logPhoneCall.due_date);
    if (!this.showFeedbackInLogPhoneCall) {
      // Clear feedback fields when switching to future date
      this.logPhoneCall.feedback_status_id = null;
      this.logPhoneCall.event_status_id = null;
      this.logPhoneCall.feedback = null;
    }
  }

  onLogMessageDateChange() {
    if (!this.logMessage || !this.logMessage.due_date) {
      this.showFeedbackInLogMessage = false;
      return;
    }

    this.showFeedbackInLogMessage = this.isPastDate(this.logMessage.due_date);
    if (!this.showFeedbackInLogMessage) {
      // Clear feedback fields when switching to future date
      this.logMessage.feedback_status_id = null;
      this.logMessage.event_status_id = null;
      this.logMessage.feedback = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/lead/dashboard/lead.component.ts